import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// accounts--index on `app/views/accounts/index.haml`.
export default class extends Controller {
  static targets = ["accountsTable", "bulkNotificationDialog"]

  connect() {
    if (!this.hasAccountsTableTarget) return

    this.#initAccountsTable()
    this.element.addEventListener("click", this.boundAddNotification)
  }

  disconnect() {
    if (this.accountsDataTable) {
      this.accountsDataTable = destroyTurboDataTable(this.accountsDataTable)
    }
    this.element.removeEventListener("click", this.boundAddNotification)
    $(this.element).find(".block-accounts, .unblock-accounts").off(".accountsIndex")
    $("#fileField").off(".accountsIndex")
  }

  bulkBlock(event) {
    event.preventDefault()
    $.get("/account/bulk_block_notifications", (data) => {
      $(this.bulkNotificationDialogTarget).html(data)
      $("#bulk-block-notification").modal("show")
      this.#bindFileField()
    })
  }

  bulkUnblock(event) {
    event.preventDefault()
    $("#bulk-unblock-notification").modal("show")
    this.#bindFileField()
  }

  boundAddNotification = (event) => {
    const button = event.target.closest(".add_notification")
    if (!button || !this.element.contains(button)) return

    event.preventDefault()
    const accountId = button.dataset.id
    $.get(`/account/${accountId}/block_notification`, (data) => {
      $("#notification_dialog").first().html(data)
      $("#add-block-notification").modal("show")
      $("#service_notification_account_id").val(accountId)
    })
  }

  #initAccountsTable() {
    this.accountsDataTable = createTurboDataTable(this.accountsTableTarget, {
      dom: '<"H"lfr>t<"F"<"toolbar">>',
      scrollX: true,
      paging: false,
      order: [[0, "asc"]],
      stateSave: true,
      serverSide: true,
      processing: true,
      searchDelay: 2000,
      ajax: {
        url: "/accounts",
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell) {
            $(cell).addClass("acc_id")
          },
        },
        {
          targets: 11,
          createdCell(cell, cellData) {
            const accountId = cellData[0]
            const isBlocking = cellData[1]
            const notificationId = cellData[2]

            if (isBlocking == false) {
              $(cell).html(
                `<button name="button" type="submit" class="new-btn add_notification" data-id="${accountId}">Block</button>` +
                  `<a class="new-btn" style="margin-left: 10px;" href="/accounts_managements/accounts/${accountId}/edit">Manage</a>` +
                  `<div id="notification_dialog"></div>`,
              )
            } else {
              let html =
                `<a data-confirm="Are you sure?" class="new-btn" rel="nofollow" data-method="post" href="/account/${accountId}/unblock">Unblock</a>`
              if (notificationId !== "") {
                html += `<a class="new-btn btn-red" style="margin-left: 10px;" href="/service_notifications/${notificationId}/edit">Notification</a>`
              }
              html += `<a class="new-btn" style="margin-left: 10px;" href="/accounts_managements/accounts/${accountId}/edit">Manage</a>`
              $(cell).html(html)
            }
          },
        },
        {
          targets: [0, 1, 3, 4, 5, 6, 7, 8, 9, 10],
          searchable: false,
        },
        {
          targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          sortable: false,
        },
      ],
    })
  }

  #bindFileField() {
    $("#fileField")
      .off(".accountsIndex")
      .on("change.accountsIndex paste.accountsIndex keyup.accountsIndex", function () {
        $(".fileName").val($(this).val().replace(/.*(\/|\\)/, ""))
      })
  }
}
